var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.854 34L121.771 34.0809L115.854 34.1618V34Z",
    fill: "#FCDFE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.857 34.1619L112.208 34.2428L109.857 34.3237V34.1619Z",
    fill: "#FCDFE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.067 34.1619L129.551 34.2428L126.067 34.3237V34.1619Z",
    fill: "#FCDFE8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.13 34.3235L107.832 34.4044L106.13 34.4853V34.3235Z",
    fill: "#FCDFE8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.256 34.3235L132.631 34.4044L131.256 34.4853V34.3235Z",
    fill: "#FCDFE8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.374 34.4854L104.59 34.5663L103.374 34.6472V34.4854Z",
    fill: "#FCDFE8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134.335 34.4854L135.713 34.5663L134.335 34.6472V34.4854Z",
    fill: "#FCDFE8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.941 34.6472L101.834 34.7308L100.941 34.8117V34.6472Z",
    fill: "#FCDFE8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.415 34.6472L138.466 34.7308L137.415 34.8117V34.6472Z",
    fill: "#FCDFE8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6733 34.8116L99.725 34.8925L98.6733 34.9734V34.8116Z",
    fill: "#FCDFE8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M139.521 34.8116L140.414 34.8925L139.521 34.9734V34.8116Z",
    fill: "#FCDFE8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7262 34.9735L97.6189 35.0544L96.7262 35.1353V34.9735Z",
    fill: "#FCDFE8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M141.466 34.9735L142.358 35.0544L141.466 35.1353V34.9735Z",
    fill: "#FCDFE8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9436 35.1354L95.8363 35.2163L94.9436 35.2972V35.1354Z",
    fill: "#FCDFE8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M143.413 35.1354L144.141 35.2163L143.413 35.2972V35.1354Z",
    fill: "#FCDFE8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3229 35.2972L94.051 35.3781L93.3229 35.459V35.2972Z",
    fill: "#FCDFE8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M145.195 35.2972L146.088 35.3781L145.195 35.459V35.2972Z",
    fill: "#FCDFE8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7021 35.4591L92.4303 35.54L91.7021 35.6209V35.4591Z",
    fill: "#FCDFE8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M146.978 35.4591L147.709 35.54L146.978 35.6209V35.4591Z",
    fill: "#FCDFE8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2429 35.6209L90.971 35.7018L90.2429 35.7827V35.6209Z",
    fill: "#FCDFE8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M148.437 35.6209L149.007 35.7021L148.437 35.7832V35.6209Z",
    fill: "#FCDFE8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7844 35.7828L89.5125 35.8637L88.7844 35.9446V35.7828Z",
    fill: "#FCDFE8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M149.734 35.7828L150.464 35.8637L149.734 35.9446V35.7828Z",
    fill: "#FCDFE8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M87.487 35.9442L88.0548 36.0254L87.487 36.1065V35.9442Z",
    fill: "#FCDFE8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M151.193 35.9442L151.76 36.0254L151.193 36.1065V35.9442Z",
    fill: "#FCDFE8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1899 36.1061L86.7578 36.1899L86.1899 36.2711V36.1061Z",
    fill: "#FCDFE8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M152.49 36.1061L153.218 36.1897L152.49 36.2706V36.1061Z",
    fill: "#FCDFE8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0544 36.2705L85.4627 36.3516L85.0544 36.4328V36.2705Z",
    fill: "#FCDFE8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M153.949 36.2705L154.517 36.3516L153.949 36.4328V36.2705Z",
    fill: "#FCDFE8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7573 36.4324L84.3279 36.5135L83.7573 36.5946V36.4324Z",
    fill: "#FCDFE8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M155.246 36.4324L155.814 36.5135L155.246 36.5946V36.4324Z",
    fill: "#FCDFE8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7862 36.5942L83.1918 36.6754L82.7862 36.7565V36.5942Z",
    fill: "#FCDFE8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M156.381 36.5942L156.787 36.6754L156.381 36.7565V36.5942Z",
    fill: "#FCDFE8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6514 36.7561L82.057 36.8372L81.6514 36.9184V36.7561Z",
    fill: "#FCDFE8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M157.514 36.7561L157.922 36.8372L157.514 36.9184V36.7561Z",
    fill: "#FCDFE8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6777 36.918L81.0861 36.9991L80.6777 37.0802V36.918Z",
    fill: "#FCDFE8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M158.487 36.918L159.055 36.9991L158.487 37.0802V36.918Z",
    fill: "#FCDFE8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5451 37.0798L79.9507 37.1609L79.5451 37.2421V37.0798Z",
    fill: "#FCDFE8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M159.623 37.0798L160.028 37.1609L159.623 37.2421V37.0798Z",
    fill: "#FCDFE8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5714 37.2417L78.9771 37.3228L78.5714 37.4039V37.2417Z",
    fill: "#FCDFE8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M160.756 37.2417L161.164 37.3228L160.756 37.4039V37.2417Z",
    fill: "#FCDFE8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4362 37.4035L77.8419 37.4847L77.4362 37.5658V37.4035Z",
    fill: "#FCDFE8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M161.729 37.4035L162.299 37.4847L161.729 37.5658V37.4035Z",
    fill: "#FCDFE8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M76.465 37.565L76.8707 37.6488L76.465 37.7299V37.565Z",
    fill: "#FCDFE8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M162.864 37.565L163.27 37.6488L162.864 37.7299V37.565Z",
    fill: "#FCDFE8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M164.809 37.8917L165.215 37.9728L164.809 38.0539V37.8917Z",
    fill: "#FCDFE8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7091 38.0531L74.1148 38.1342L73.7091 38.2154V38.0531Z",
    fill: "#FCDFE8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M165.62 38.0531L166.026 38.1342L165.62 38.2154V38.0531Z",
    fill: "#FCDFE8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M166.591 38.215L166.999 38.2961L166.591 38.3772V38.215Z",
    fill: "#FCDFE8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M71.924 38.3768L72.3323 38.458L71.924 38.5391V38.3768Z",
    fill: "#FCDFE8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M167.403 38.3768L167.809 38.458L167.403 38.5391V38.3768Z",
    fill: "#FCDFE8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1147 38.5387L71.5203 38.6198L71.1147 38.701V38.5387Z",
    fill: "#FCDFE8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M169.186 38.7006L169.591 38.7817L169.186 38.8628V38.7006Z",
    fill: "#FCDFE8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3325 38.8624L69.7382 38.9436L69.3325 39.0247V38.8624Z",
    fill: "#FCDFE8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M169.997 38.8624L170.403 38.9436L169.997 39.0247V38.8624Z",
    fill: "#FCDFE8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M170.968 39.0243L171.376 39.1054L170.968 39.1893V39.0243Z",
    fill: "#FCDFE8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M171.78 39.1887L172.185 39.2698L171.78 39.351V39.1887Z",
    fill: "#FCDFE8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6317 39.8357L65.0373 39.9168L64.6317 39.998V39.8357Z",
    fill: "#FCDFE8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M174.86 39.8357L175.265 39.9168L174.86 39.998V39.8357Z",
    fill: "#FCDFE8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M176.319 40.1594L176.724 40.2406L176.319 40.3217V40.1594Z",
    fill: "#FCDFE8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M177.777 40.4832L178.183 40.5643L177.777 40.6481V40.4832Z",
    fill: "#FCDFE8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9021 40.6476L61.3077 40.7287L60.9021 40.8098V40.6476Z",
    fill: "#FCDFE8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M113.748 47.6161L124.527 47.697L113.748 47.7779V47.6161Z",
    fill: "#FCDFE8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M108.721 47.778L110.749 47.8589L108.721 47.9398V47.778Z",
    fill: "#FCDFE8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M128.661 47.778L130.363 47.8589L128.661 47.9398V47.778Z",
    fill: "#FCDFE8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M105.641 47.9399L106.858 48.0235L105.641 48.1044V47.9399Z",
    fill: "#FCDFE8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M131.903 47.9399L133.442 48.0235L131.903 48.1044V47.9399Z",
    fill: "#FCDFE8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M102.886 48.1038L104.102 48.1847L102.886 48.2656V48.1038Z",
    fill: "#FCDFE8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M134.983 48.1038L136.361 48.1847L134.983 48.2656V48.1038Z",
    fill: "#FCDFE8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M100.618 48.2657L101.672 48.3466L100.618 48.4275V48.2657Z",
    fill: "#FCDFE8"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M137.739 48.2657L138.631 48.3466L137.739 48.4275V48.2657Z",
    fill: "#FCDFE8"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5089 48.4276L99.4015 48.5085L98.5089 48.5894V48.4276Z",
    fill: "#FCDFE8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M139.683 48.4276L140.576 48.5085L139.683 48.5894V48.4276Z",
    fill: "#FCDFE8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7258 48.5894L97.6184 48.6703L96.7258 48.7512V48.5894Z",
    fill: "#FCDFE8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M141.63 48.5894L142.358 48.6703L141.63 48.7512V48.5894Z",
    fill: "#FCDFE8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1055 48.7513L95.8363 48.8322L95.1055 48.9131V48.7513Z",
    fill: "#FCDFE8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M143.413 48.7513L144.303 48.8322L143.413 48.9131V48.7513Z",
    fill: "#FCDFE8"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4843 48.9132L94.0522 48.9943L93.4843 49.0754V48.9132Z",
    fill: "#FCDFE8"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M145.357 48.9132L145.925 48.9943L145.357 49.0754V48.9132Z",
    fill: "#FCDFE8"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0259 49.075L92.5938 49.1561L92.0259 49.2373V49.075Z",
    fill: "#FCDFE8"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M146.816 49.075L147.384 49.1561L146.816 49.2373V49.075Z",
    fill: "#FCDFE8"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5666 49.2369L91.1345 49.318L90.5666 49.3991V49.2369Z",
    fill: "#FCDFE8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M148.113 49.2369L148.681 49.318L148.113 49.3991V49.2369Z",
    fill: "#FCDFE8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2695 49.3983L89.8402 49.4822L89.2695 49.5633V49.3983Z",
    fill: "#FCDFE8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M149.572 49.3983L150.14 49.4822L149.572 49.5633V49.3983Z",
    fill: "#FCDFE8"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9726 49.5631L88.5432 49.6443L87.9726 49.7254V49.5631Z",
    fill: "#FCDFE8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M150.869 49.5631L151.437 49.6443L150.869 49.7254V49.5631Z",
    fill: "#FCDFE8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6755 49.725L87.2461 49.8061L86.6755 49.8873V49.725Z",
    fill: "#FCDFE8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M152.328 49.725L152.896 49.8061L152.328 49.8873V49.725Z",
    fill: "#FCDFE8"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5429 49.8869L85.9485 49.968L85.5429 50.0491V49.8869Z",
    fill: "#FCDFE8"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M153.625 49.8869L154.031 49.968L153.625 50.0491V49.8869Z",
    fill: "#FCDFE8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4073 50.0487L84.813 50.1299L84.4073 50.211V50.0487Z",
    fill: "#FCDFE8"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M154.758 50.0487L155.166 50.1299L154.758 50.211V50.0487Z",
    fill: "#FCDFE8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4336 50.2102L83.8392 50.2913L83.4336 50.3724V50.2102Z",
    fill: "#FCDFE8"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M155.731 50.2102L156.299 50.2913L155.731 50.3724V50.2102Z",
    fill: "#FCDFE8"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2985 50.372L82.7068 50.4532L82.2985 50.5343V50.372Z",
    fill: "#FCDFE8"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M156.867 50.372L157.272 50.4532L156.867 50.5343V50.372Z",
    fill: "#FCDFE8"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3277 50.5339L81.7333 50.615L81.3277 50.6962V50.5339Z",
    fill: "#FCDFE8"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M157.84 50.5339L158.408 50.615L157.84 50.6962V50.5339Z",
    fill: "#FCDFE8"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1926 50.6958L80.7605 50.7769L80.1926 50.858V50.6958Z",
    fill: "#FCDFE8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M158.973 50.6958L159.381 50.7769L158.973 50.858V50.6958Z",
    fill: "#FCDFE8"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2188 50.8576L79.6272 50.9387L79.2188 51.0226V50.8576Z",
    fill: "#FCDFE8"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M160.108 50.8576L160.514 50.9387L160.108 51.0226V50.8576Z",
    fill: "#FCDFE8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0862 51.022L78.6541 51.1032L78.0862 51.1843V51.022Z",
    fill: "#FCDFE8"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M161.082 51.022L161.65 51.1032L161.082 51.1843V51.022Z",
    fill: "#FCDFE8"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M162.053 51.1839L162.461 51.265L162.053 51.3462V51.1839Z",
    fill: "#FCDFE8"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M163.026 51.3458L163.432 51.4269L163.026 51.508V51.3458Z",
    fill: "#FCDFE8"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4917 51.5076L75.8974 51.5887L75.4917 51.6699V51.5076Z",
    fill: "#FCDFE8"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M163.838 51.5076L164.243 51.5887L163.838 51.6699V51.5076Z",
    fill: "#FCDFE8"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M165.62 51.8309L166.026 51.912L165.62 51.9932V51.8309Z",
    fill: "#FCDFE8"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8977 51.9928L73.3033 52.0739L72.8977 52.155V51.9928Z",
    fill: "#FCDFE8"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M167.403 52.1546L167.809 52.2358L167.403 52.3169V52.1546Z",
    fill: "#FCDFE8"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M168.215 52.3165L168.62 52.3976L168.215 52.4815V52.3165Z",
    fill: "#FCDFE8"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3032 52.4809L70.7116 52.562L70.3032 52.6432V52.4809Z",
    fill: "#FCDFE8"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0351 52.9665L68.4407 53.0476L68.0351 53.1288V52.9665Z",
    fill: "#FCDFE8"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5761 53.2902L66.9818 53.3713L66.5761 53.4525V53.2902Z",
    fill: "#FCDFE8"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M172.915 53.2902L173.321 53.3713L172.915 53.4525V53.2902Z",
    fill: "#FCDFE8"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1173 53.6135L65.5229 53.6946L65.1173 53.7758V53.6135Z",
    fill: "#FCDFE8"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M174.374 53.6135L174.78 53.6946L174.374 53.7758V53.6135Z",
    fill: "#FCDFE8"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M19.243 57.6669L19.3242 58.0725H19.1619L19.243 57.6669Z",
    fill: "#FCDFE8"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0809 59.6113L19.1619 60.504H19L19.0809 59.6113Z",
    fill: "#FCDFE8"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2428 61.2321L19.3237 61.9629H19.1619L19.2428 61.2321Z",
    fill: "#FCDFE8"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M237.106 61.5583L238.161 62.1247L237.918 62.0438L237.106 61.7201V61.5583Z",
    fill: "#FCDFE8"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M242.295 64.1498L242.863 64.5582L242.619 64.4771L242.295 64.1498Z",
    fill: "#FCDFE8"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M101.753 70.1472L103.131 70.2308L101.753 70.3117V70.1472Z",
    fill: "#FCDFE8"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9673 70.3121L100.376 70.3932L99.9673 70.4743V70.3121Z",
    fill: "#FCDFE8"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M104.506 70.3121L104.915 70.3932L104.506 70.4743V70.3121Z",
    fill: "#FCDFE8"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8347 70.4739L99.2404 70.555L98.8347 70.6362V70.4739Z",
    fill: "#FCDFE8"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M105.48 70.4739L105.885 70.555L105.48 70.6362V70.4739Z",
    fill: "#FCDFE8"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M110.342 71.9328L110.913 72.3384L110.669 72.2573L110.342 71.9328Z",
    fill: "#FCDFE8"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M121.366 84.4136L122.256 84.4945L121.366 84.5754V84.4136Z",
    fill: "#FCDFE8"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M122.826 84.4136L125.339 84.4945L122.826 84.5754V84.4136Z",
    fill: "#FCDFE8"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M128.173 84.575L130.363 84.6559L128.173 84.7368V84.575Z",
    fill: "#FCDFE8"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M131.741 84.7369L132.795 84.8178L131.741 84.8987V84.7369Z",
    fill: "#FCDFE8"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M134.173 84.8987L135.387 84.9797L134.173 85.0633V84.8987Z",
    fill: "#FCDFE8"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M136.603 85.0632L137.82 85.1441L136.603 85.225V85.0632Z",
    fill: "#FCDFE8"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M138.712 85.225L139.28 85.3061L138.712 85.3873V85.225Z",
    fill: "#FCDFE8"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M140.171 85.3869L140.899 85.4678L140.171 85.5487V85.3869Z",
    fill: "#FCDFE8"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M141.792 85.5487L142.52 85.6296L141.792 85.7105V85.5487Z",
    fill: "#FCDFE8"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M143.413 85.7106L143.98 85.7917L143.413 85.8729V85.7106Z",
    fill: "#FCDFE8"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M144.871 85.8725L145.6 85.9534L144.871 86.0343V85.8725Z",
    fill: "#FCDFE8"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M146.169 86.0343L146.737 86.1155L146.169 86.1966V86.0343Z",
    fill: "#FCDFE8"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M147.463 86.1958L147.872 86.2769L147.463 86.358V86.1958Z",
    fill: "#FCDFE8"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M148.599 86.3576L149.007 86.4388L148.599 86.5226V86.3576Z",
    fill: "#FCDFE8"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M149.734 86.522L150.302 86.6032L149.734 86.6843V86.522Z",
    fill: "#FCDFE8"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M83.272 86.6839L83.3531 87.0895H83.1908L83.272 86.6839Z",
    fill: "#FCDFE8"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M150.869 86.6839L151.437 86.765L150.869 86.8462V86.6839Z",
    fill: "#FCDFE8"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M152.004 86.8458L152.572 86.9269L152.004 87.008V86.8458Z",
    fill: "#FCDFE8"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M153.137 87.0076L153.545 87.0888L153.137 87.1699V87.0076Z",
    fill: "#FCDFE8"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M154.111 87.1695L154.516 87.2506L154.111 87.3317V87.1695Z",
    fill: "#FCDFE8"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M155.893 87.4932L156.299 87.5743L155.893 87.6555V87.4932Z",
    fill: "#FCDFE8"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M156.867 87.6551L157.272 87.7362L156.867 87.8173V87.6551Z",
    fill: "#FCDFE8"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1101 87.8165L83.1912 88.2249H83.029L83.1101 87.8165Z",
    fill: "#FCDFE8"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M158.649 87.9813L159.055 88.0625L158.649 88.1436V87.9813Z",
    fill: "#FCDFE8"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M159.623 88.1428L160.028 88.2239L159.623 88.305V88.1428Z",
    fill: "#FCDFE8"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M161.244 88.4665L161.649 88.5476L161.244 88.6288V88.4665Z",
    fill: "#FCDFE8"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M163.511 88.9521L163.92 89.0332L163.511 89.1143V88.9521Z",
    fill: "#FCDFE8"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M82.948 89.2758L83.0289 90.6539H82.8671L82.948 89.2758Z",
    fill: "#FCDFE8"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M165.782 89.4402L166.188 89.5214L165.782 89.6025V89.4402Z",
    fill: "#FCDFE8"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M82.948 91.061L83.0289 92.439H82.8671L82.948 91.061Z",
    fill: "#FCDFE8"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1101 93.4906L83.1912 93.8989H83.029L83.1101 93.4906Z",
    fill: "#FCDFE8"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M83.272 94.6262L83.3531 95.0318H83.1908L83.272 94.6262Z",
    fill: "#FCDFE8"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M121.366 97.8677L122.094 97.9486L121.366 98.0295V97.8677Z",
    fill: "#FCDFE8"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M124.608 98.0295L127.283 98.1104L124.608 98.1913V98.0295Z",
    fill: "#FCDFE8"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M129.632 98.1914L130.848 98.2723L129.632 98.3559V98.1914Z",
    fill: "#FCDFE8"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M132.064 98.3558L133.281 98.4367L132.064 98.5176V98.3558Z",
    fill: "#FCDFE8"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M134.497 98.5177L135.713 98.5986L134.497 98.6795V98.5177Z",
    fill: "#FCDFE8"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M136.927 98.6795L137.498 98.7607L136.927 98.8418V98.6795Z",
    fill: "#FCDFE8"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M138.386 98.841L139.116 98.9219L138.386 99.0028V98.841Z",
    fill: "#FCDFE8"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M140.007 99.0028L140.737 99.0837L140.007 99.1646V99.0028Z",
    fill: "#FCDFE8"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M141.63 99.1647L142.358 99.2456L141.63 99.3265V99.1647Z",
    fill: "#FCDFE8"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M143.089 99.3265L143.817 99.4075L143.089 99.4883V99.3265Z",
    fill: "#FCDFE8"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M144.548 99.4884L144.954 99.5695L144.548 99.6507V99.4884Z",
    fill: "#FCDFE8"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M145.681 99.6503L146.089 99.7314L145.681 99.8152V99.6503Z",
    fill: "#FCDFE8"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M146.816 99.8147L147.384 99.8958L146.816 99.9769V99.8147Z",
    fill: "#FCDFE8"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M147.951 99.9765L148.519 100.058L147.951 100.139V99.9765Z",
    fill: "#FCDFE8"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M149.086 100.138L149.654 100.22L149.086 100.301V100.138Z",
    fill: "#FCDFE8"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M150.381 100.3L150.789 100.381L150.381 100.463V100.3Z",
    fill: "#FCDFE8"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M119.584 100.462L119.665 100.705L119.338 100.867L119.584 100.462Z",
    fill: "#FCDFE8"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M151.354 100.462L151.76 100.543L151.354 100.624V100.462Z",
    fill: "#FCDFE8"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M152.328 100.624L152.734 100.705L152.328 100.786V100.624Z",
    fill: "#FCDFE8"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M153.137 100.785L153.545 100.867L153.137 100.948V100.785Z",
    fill: "#FCDFE8"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M154.111 100.947L154.516 101.028L154.111 101.11V100.947Z",
    fill: "#FCDFE8"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M155.084 101.109L155.49 101.19L155.084 101.274V101.109Z",
    fill: "#FCDFE8"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M155.893 101.274L156.299 101.355L155.893 101.436V101.274Z",
    fill: "#FCDFE8"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M156.867 101.435L157.272 101.517L156.867 101.598V101.435Z",
    fill: "#FCDFE8"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M159.297 101.921L159.705 102.002L159.297 102.083V101.921Z",
    fill: "#FCDFE8"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M161.567 102.406L161.973 102.487L161.567 102.568V102.406Z",
    fill: "#FCDFE8"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6733 111.16L99.0789 111.241L98.6733 111.322V111.16Z",
    fill: "#FCDFE8"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M105.803 111.16L106.212 111.241L105.803 111.322V111.16Z",
    fill: "#FCDFE8"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M99.644 111.322L100.05 111.403L99.644 111.484V111.322Z",
    fill: "#FCDFE8"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M104.833 111.322L105.238 111.403L104.833 111.484V111.322Z",
    fill: "#FCDFE8"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M101.103 111.484L103.778 111.565L101.103 111.648V111.484Z",
    fill: "#FCDFE8"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M113.586 134.827L116.747 134.907L113.586 134.988V134.827Z",
    fill: "#FCDFE8"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M125.094 134.827L127.122 134.907L125.094 134.988V134.827Z",
    fill: "#FCDFE8"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M110.83 134.988L112.047 135.069L110.83 135.15V134.988Z",
    fill: "#FCDFE8"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M128.985 134.988L130.201 135.069L128.985 135.15V134.988Z",
    fill: "#FCDFE8"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M108.074 135.15L109.291 135.231L108.074 135.315V135.15Z",
    fill: "#FCDFE8"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M131.579 135.15L132.469 135.231L131.579 135.315V135.15Z",
    fill: "#FCDFE8"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M106.13 135.315L106.858 135.396L106.13 135.476V135.315Z",
    fill: "#FCDFE8"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M133.524 135.315L134.255 135.396L133.524 135.476V135.315Z",
    fill: "#FCDFE8"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M104.671 135.477L105.239 135.558L104.671 135.639V135.477Z",
    fill: "#FCDFE8"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M135.306 135.477L136.037 135.557L135.306 135.638V135.477Z",
    fill: "#FCDFE8"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M103.047 135.638L103.618 135.72L103.047 135.801V135.638Z",
    fill: "#FCDFE8"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M136.927 135.638L137.82 135.719L136.927 135.8V135.638Z",
    fill: "#FCDFE8"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M101.427 135.8L101.997 135.881L101.427 135.963V135.8Z",
    fill: "#FCDFE8"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M138.547 135.8L139.118 135.881L138.547 135.963V135.8Z",
    fill: "#FCDFE8"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9673 135.962L100.538 136.043L99.9673 136.124V135.962Z",
    fill: "#FCDFE8"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M139.845 135.962L140.253 136.043L139.845 136.124V135.962Z",
    fill: "#FCDFE8"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8347 136.124L99.4026 136.205L98.8347 136.286V136.124Z",
    fill: "#FCDFE8"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M140.98 136.124L141.548 136.205L140.98 136.286V136.124Z",
    fill: "#FCDFE8"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6995 136.285L98.2674 136.367L97.6995 136.448V136.285Z",
    fill: "#FCDFE8"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M142.277 136.285L142.845 136.367L142.277 136.448V136.285Z",
    fill: "#FCDFE8"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5644 136.447L97.1323 136.528L96.5644 136.61V136.447Z",
    fill: "#FCDFE8"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M143.574 136.447L143.98 136.528L143.574 136.61V136.447Z",
    fill: "#FCDFE8"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4292 136.609L95.9998 136.69L95.4292 136.774V136.609Z",
    fill: "#FCDFE8"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M144.548 136.609L144.954 136.69L144.548 136.774V136.609Z",
    fill: "#FCDFE8"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2962 136.774L94.7018 136.855L94.2962 136.936V136.774Z",
    fill: "#FCDFE8"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M145.519 136.774L145.925 136.855L145.519 136.936V136.774Z",
    fill: "#FCDFE8"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3229 136.935L93.7286 137.017L93.3229 137.098V136.935Z",
    fill: "#FCDFE8"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M146.493 136.935L146.898 137.017L146.493 137.098V136.935Z",
    fill: "#FCDFE8"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M147.463 137.097L147.872 137.178L147.463 137.26V137.097Z",
    fill: "#FCDFE8"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5403 137.259L91.9459 137.34L91.5403 137.421V137.259Z",
    fill: "#FCDFE8"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M148.437 137.259L148.842 137.34L148.437 137.421V137.259Z",
    fill: "#FCDFE8"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M149.41 137.421L149.816 137.502L149.41 137.583V137.421Z",
    fill: "#FCDFE8"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7551 137.583L90.1635 137.664L89.7551 137.745V137.583Z",
    fill: "#FCDFE8"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M150.219 137.583L150.627 137.664L150.219 137.745V137.583Z",
    fill: "#FCDFE8"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9462 137.745L89.3519 137.826L88.9462 137.907V137.745Z",
    fill: "#FCDFE8"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M151.031 137.745L151.437 137.826L151.031 137.907V137.745Z",
    fill: "#FCDFE8"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1632 138.068L87.5689 138.149L87.1632 138.23V138.068Z",
    fill: "#FCDFE8"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7047 138.395L86.1104 138.476L85.7047 138.557V138.395Z",
    fill: "#FCDFE8"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M154.923 138.557L155.328 138.638L154.923 138.719V138.557Z",
    fill: "#FCDFE8"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1366 139.204L82.545 139.285L82.1366 139.366V139.204Z",
    fill: "#FCDFE8"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M118.61 148.281L123.553 148.362L118.61 148.443V148.281Z",
    fill: "#FCDFE8"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M113.098 148.443L114.314 148.524L113.098 148.607V148.443Z",
    fill: "#FCDFE8"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M126.391 148.443L127.931 148.524L126.391 148.607V148.443Z",
    fill: "#FCDFE8"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M110.342 148.607L111.558 148.688L110.342 148.769V148.607Z",
    fill: "#FCDFE8"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M129.47 148.607L130.525 148.688L129.47 148.769V148.607Z",
    fill: "#FCDFE8"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M107.913 148.769L108.802 148.85L107.913 148.931V148.769Z",
    fill: "#FCDFE8"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M131.741 148.769L132.469 148.85L131.741 148.931V148.769Z",
    fill: "#FCDFE8"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M106.291 148.931L107.02 149.012L106.291 149.093V148.931Z",
    fill: "#FCDFE8"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M133.524 148.931L134.255 149.012L133.524 149.093V148.931Z",
    fill: "#FCDFE8"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M104.671 149.092L105.399 149.173L104.671 149.254V149.092Z",
    fill: "#FCDFE8"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M135.144 149.092L135.875 149.173L135.144 149.254V149.092Z",
    fill: "#FCDFE8"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M103.047 149.254L103.778 149.335L103.047 149.416V149.254Z",
    fill: "#FCDFE8"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M136.927 149.254L137.498 149.335L136.927 149.417V149.254Z",
    fill: "#FCDFE8"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M101.753 149.416L102.158 149.497L101.753 149.578V149.416Z",
    fill: "#FCDFE8"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M138.062 149.416L138.633 149.497L138.062 149.578V149.416Z",
    fill: "#FCDFE8"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M100.618 149.578L101.023 149.659L100.618 149.74V149.578Z",
    fill: "#FCDFE8"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M139.359 149.578L139.927 149.659L139.359 149.74V149.578Z",
    fill: "#FCDFE8"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4821 149.74L99.8877 149.821L99.4821 149.902V149.74Z",
    fill: "#FCDFE8"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M140.494 149.74L141.062 149.821L140.494 149.902V149.74Z",
    fill: "#FCDFE8"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M98.347 149.902L98.7553 149.983L98.347 150.064V149.902Z",
    fill: "#FCDFE8"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M141.792 149.902L142.36 149.983L141.792 150.064V149.902Z",
    fill: "#FCDFE8"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2144 150.064L97.62 150.147L97.2144 150.229V150.064Z",
    fill: "#FCDFE8"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M142.924 150.064L143.333 150.147L142.924 150.229V150.064Z",
    fill: "#FCDFE8"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0788 150.228L96.4845 150.309L96.0788 150.39V150.228Z",
    fill: "#FCDFE8"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1055 150.39L95.5112 150.471L95.1055 150.552V150.39Z",
    fill: "#FCDFE8"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M144.71 150.39L145.115 150.471L144.71 150.552V150.39Z",
    fill: "#FCDFE8"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2962 150.551L94.7018 150.632L94.2962 150.714V150.551Z",
    fill: "#FCDFE8"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M145.681 150.551L146.089 150.632L145.681 150.714V150.551Z",
    fill: "#FCDFE8"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M146.654 150.713L147.06 150.794L146.654 150.875V150.713Z",
    fill: "#FCDFE8"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M92.511 150.875L92.9194 150.956L92.511 151.037V150.875Z",
    fill: "#FCDFE8"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M147.628 150.875L148.033 150.956L147.628 151.037V150.875Z",
    fill: "#FCDFE8"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7285 151.199L91.1341 151.28L90.7285 151.361V151.199Z",
    fill: "#FCDFE8"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M150.707 151.523L151.113 151.606L150.707 151.687V151.523Z",
    fill: "#FCDFE8"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M152.976 152.011L153.381 152.092L152.976 152.173V152.011Z",
    fill: "#FCDFE8"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9848 160.926L58.3904 161.007L57.9848 161.089V160.926Z",
    fill: "#FCDFE8"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M155.408 176.324L156.136 176.405L155.408 176.486V176.324Z",
    fill: "#FCDFE8"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M159.135 176.324L159.866 176.405L159.135 176.486V176.324Z",
    fill: "#FCDFE8"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M154.434 176.486L154.84 176.567L154.434 176.648V176.486Z",
    fill: "#FCDFE8"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M160.594 176.486L161.002 176.567L160.594 176.648V176.486Z",
    fill: "#FCDFE8"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M355.117 179.893L355.845 181.271H355.683L355.117 179.893Z",
    fill: "#FCDFE8"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M342.798 185.564L343.041 185.972H342.879L342.798 185.564Z",
    fill: "#FCDFE8"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M346.04 192.211L346.283 192.779H346.121L346.04 192.211Z",
    fill: "#FCDFE8"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M176.804 193.185L176.885 193.59H176.723L176.804 193.185Z",
    fill: "#FCDFE8"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M138.386 193.67L138.467 194.076H138.305L138.386 193.67Z",
    fill: "#FCDFE8"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M176.966 194.317L177.047 194.726H176.885L176.966 194.317Z",
    fill: "#FCDFE8"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M138.224 194.805L138.305 196.022H138.143L138.224 194.805Z",
    fill: "#FCDFE8"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M177.13 196.588L177.211 197.316H177.047L177.13 196.588Z",
    fill: "#FCDFE8"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M138.224 197.885L138.305 199.101H138.143L138.224 197.885Z",
    fill: "#FCDFE8"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M176.966 199.021L177.047 199.589H176.885L176.966 199.021Z",
    fill: "#FCDFE8"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M138.386 199.83L138.467 200.235H138.305L138.386 199.83Z",
    fill: "#FCDFE8"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M176.804 200.153C176.783 200.62 176.917 200.916 177.211 201.046L176.723 200.722L176.804 200.153Z",
    fill: "#FCDFE8"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M161.244 217.175L161.649 217.256L161.244 217.337V217.175Z",
    fill: "#FCDFE8"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M154.596 217.337L155.004 217.418L154.596 217.499V217.337Z",
    fill: "#FCDFE8"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M160.27 217.337L160.676 217.418L160.27 217.499V217.337Z",
    fill: "#FCDFE8"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M155.731 217.499L156.786 217.58L155.731 217.661V217.499Z",
    fill: "#FCDFE8"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M158.487 217.499L159.704 217.58L158.487 217.661V217.499Z",
    fill: "#FCDFE8"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M251.21 227.711L251.616 228.279L251.292 228.117L251.21 227.711Z",
    fill: "#FCDFE8"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M375.704 237.112L375.785 237.521H375.623L375.704 237.112Z",
    fill: "#FCDFE8"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M362.25 239.221L362.331 239.627H362.169L362.25 239.221Z",
    fill: "#FCDFE8"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M376.675 241.489L376.756 241.898H376.594L376.675 241.489Z",
    fill: "#FCDFE8"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M362.897 241.977L362.978 242.383H362.816L362.897 241.977Z",
    fill: "#FCDFE8"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M363.383 244.083L363.466 244.489H363.301L363.383 244.083Z",
    fill: "#FCDFE8"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M377.325 244.569L377.406 244.977H377.244L377.325 244.569Z",
    fill: "#FCDFE8"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M377.487 245.381L377.568 245.786H377.406L377.487 245.381Z",
    fill: "#FCDFE8"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M377.81 247.163L377.892 247.569H377.729L377.81 247.163Z",
    fill: "#FCDFE8"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M377.972 247.975L378.053 248.38H377.891L377.972 247.975Z",
    fill: "#FCDFE8"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M364.356 249.107L364.437 249.516H364.275L364.356 249.107Z",
    fill: "#FCDFE8"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M378.299 249.758L378.38 250.163H378.215L378.299 249.758Z",
    fill: "#FCDFE8"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M364.518 249.919L364.599 250.325H364.437L364.518 249.919Z",
    fill: "#FCDFE8"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M378.46 250.567L378.542 250.975H378.379L378.46 250.567Z",
    fill: "#FCDFE8"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M364.68 250.731L364.761 251.137H364.599L364.68 250.731Z",
    fill: "#FCDFE8"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M364.842 251.54L364.923 251.946H364.76L364.842 251.54Z",
    fill: "#FCDFE8"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M378.622 251.54L378.703 251.946H378.541L378.622 251.54Z",
    fill: "#FCDFE8"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M365.006 252.352L365.087 252.758H364.922L365.006 252.352Z",
    fill: "#FCDFE8"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M378.784 252.514L378.865 252.919H378.703L378.784 252.514Z",
    fill: "#FCDFE8"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M222.355 252.676L261.504 252.756L222.355 252.837V252.676Z",
    fill: "#FCDFE8"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M327.558 252.676L332.666 252.756L327.558 252.837V252.676Z",
    fill: "#FCDFE8"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M333.718 252.676L340.77 252.756L333.718 252.837V252.676Z",
    fill: "#FCDFE8"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M350.74 252.676L352.765 252.756L350.74 252.837V252.676Z",
    fill: "#FCDFE8"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M378.946 253.484L379.027 253.893H378.864L378.946 253.484Z",
    fill: "#FCDFE8"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M314.105 254.62L314.186 255.026H314.024L314.105 254.62Z",
    fill: "#FCDFE8"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M379.107 254.62L379.189 255.026H379.026L379.107 254.62Z",
    fill: "#FCDFE8"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M379.269 255.593L379.35 255.999H379.188L379.269 255.593Z",
    fill: "#FCDFE8"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M379.431 256.564L379.512 256.972H379.35L379.431 256.564Z",
    fill: "#FCDFE8"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M379.919 258.997L380 260.698H379.838L379.919 258.997Z",
    fill: "#FCDFE8"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M277.469 259.32L277.55 259.729H277.388L277.469 259.32Z",
    fill: "#FCDFE8"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M315.078 259.482L315.159 259.891H314.997L315.078 259.482Z",
    fill: "#FCDFE8"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M277.469 259.97L277.55 260.376H277.388L277.469 259.97Z",
    fill: "#FCDFE8"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M315.402 261.106L315.483 261.511H315.321L315.402 261.106Z",
    fill: "#FCDFE8"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M315.564 262.076L315.807 262.482L315.483 262.32L315.564 262.076Z",
    fill: "#FCDFE8"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M373.595 266.777L374.003 266.858L373.595 266.939V266.777Z",
    fill: "#FCDFE8"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M100.617 70.3121H103.859L104.021 70.4739H105.237V111.241C105.237 111.349 104.994 111.376 104.506 111.322L104.344 111.484H100.294L96.5639 110.675L92.9989 109.054C91.0842 107.94 89.4364 106.562 88.053 104.92L86.1086 102.325L84.326 98.7603L83.1907 94.5452L83.0289 91.1419L82.8671 90.8156L83.0289 90.6539V88.3858L83.1912 88.2249L83.3525 86.4387L84.0024 84.0089L85.1351 81.2528C86.3783 78.8204 87.9721 76.7411 89.9192 75.0125C91.3781 73.7154 93.0528 72.634 94.9432 71.771L97.2139 70.9593L100.617 70.3121Z",
    fill: "#B24387"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M156.705 176.324H158.487L159.38 176.486V217.418L159.297 217.499H158.002L157.352 217.66L157.19 217.499H155.246L153.463 217.175L150.057 216.04C147.638 214.894 145.556 213.408 143.817 211.582C141.959 209.605 140.5 207.227 139.44 204.449L138.467 200.884L138.143 196.183L138.305 196.022V194.236L138.467 194.076L138.631 192.292L140.252 187.591C141.514 185.019 143.165 182.832 145.195 181.025C146.686 179.709 148.415 178.627 150.381 177.783L153.949 176.648L156.543 176.486L156.705 176.324Z",
    fill: "#B24387"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M115.369 34L115.775 34.0811L115.369 34.1623V34Z",
    fill: "#FFFEFE"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M121.852 34L122.423 34.0811L121.852 34.1623V34Z",
    fill: "#FFFEFE"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M128.011 47.778L128.582 47.8591L128.011 47.9403V47.778Z",
    fill: "#FFFEFE"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0809 58.802L19.1619 59.5301H19L19.0809 58.802Z",
    fill: "#FFFEFE"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M125.42 84.4136L125.825 84.4947L125.42 84.5758V84.4136Z",
    fill: "#FFFEFE"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M332.747 252.676L333.637 252.756L332.747 252.837V252.676Z",
    fill: "#FFFEFE"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M340.851 252.676L350.659 252.756L340.851 252.837V252.676Z",
    fill: "#FFFEFE"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M352.846 252.676L364.922 252.758L352.846 252.837V252.676Z",
    fill: "#FFFEFE"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M98.347 34.9737L98.8351 34.9735L102.319 38.4577L111.073 47.6968L99.9678 48.2659L99.8059 48.4279L94.4583 48.7513L94.2964 48.9133L92.9994 48.9131L92.8375 49.0749H91.5404L91.3785 49.2369L86.3518 49.7248L86.19 49.8866H85.2164L85.0547 50.0484H84.0838L82.9484 50.3723L81.9749 50.372L80.8395 50.6959L76.9508 51.1838L72.574 52.1546H71.7623L62.5231 54.2635L51.906 43.1582L60.7406 40.8093L76.1391 37.7296H77.1127L78.2479 37.4035L79.2188 37.4033L84.7311 36.4324L88.4607 36.1061L88.6225 35.9443L96.2409 35.2971L96.4026 35.1355L98.1852 35.1353L98.347 34.9737Z",
    fill: "#EF4871"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M105.237 70.6354C106.534 70.6677 107.615 70.9644 108.478 71.5253V110.432L108.074 110.512L106.129 111.16H105.237V70.6354Z",
    fill: "#EF4871"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M119.258 134.827L127.849 134.988L128.011 135.15H130.767L130.929 135.315H132.876L133.038 135.476H134.659L136.441 135.8L138.062 135.8L139.359 136.124L144.221 136.609L145.195 136.935L151.516 137.906L152.328 138.23L155.408 138.718L160.108 140.015H160.755L167.565 141.959L177.454 145.363L183.451 147.795C194.279 152.474 204.222 158.04 213.278 164.491C221.74 170.456 229.493 177.131 236.54 184.512C244.849 193.114 252.197 202.677 258.586 213.203C262.022 218.952 265.155 225.004 267.987 231.357L272.526 242.867L275.282 251.621L274.715 251.216L256.72 238.571H256.315L254.371 233.79L250.641 226.333C247.95 221.352 245.032 216.595 241.888 212.067C235.933 203.489 229.207 195.679 221.708 188.646C210.813 178.304 198.224 169.658 183.937 162.708L178.589 160.276L169.997 156.873L158.649 153.307L148.922 151.037L142.439 149.901L136.441 149.254L136.279 149.092L128.337 148.443L109.776 135.396L110.18 135.15L119.096 134.988L119.258 134.827Z",
    fill: "#EF4871"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M107.424 135.315L107.832 135.396L107.424 135.477V135.315Z",
    fill: "#EF4871"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M115.207 148.281L116.259 148.362L115.207 148.443V148.281Z",
    fill: "#EF4871"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M124.932 148.281L125.986 148.362L124.932 148.443V148.281Z",
    fill: "#EF4871"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M254.614 150.228L276.498 153.631L277.876 155.009C289.656 168.086 299.812 182.783 308.35 199.102L308.107 199.021L291.735 196.426L291.492 196.507C282.024 180.2 270.705 165.745 257.532 153.146L254.614 150.228Z",
    fill: "#EF4871"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M176.966 195.614L177.047 196.023H176.885L176.966 195.614Z",
    fill: "#EF4871"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M176.966 197.885L177.047 198.291H176.885L176.966 197.885Z",
    fill: "#EF4871"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M261.585 252.514L261.747 252.676H270.501L271.633 252.999H271.959L272.769 253.323C272.93 253.053 273.092 253.107 273.257 253.485C273.99 253.625 274.556 253.924 274.958 254.377L275.201 254.782C275.449 254.706 275.53 254.787 275.444 255.024L276.091 255.513V255.917C276.417 255.788 276.525 255.922 276.417 256.322C276.903 256.971 277.226 257.78 277.388 258.754V261.022C276.989 263.001 276.096 264.487 274.716 265.482L273.418 266.292L270.986 266.939H249.913V266.777H269.77V252.837H261.747L261.585 252.514Z",
    fill: "#EF4871"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M216.843 252.837L217.413 252.919L216.843 253V252.837Z",
    fill: "#EF4871"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M327.801 252.837H347.256V266.777H327.801V252.837Z",
    fill: "#EF4871"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M214.899 253.484L215.142 253.566L214.737 253.812L214.899 253.484Z",
    fill: "#EF4871"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M211.172 258.673L211.253 259.079H211.091L211.172 258.673Z",
    fill: "#EF4871"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M211.172 260.617L211.253 261.188H211.091L211.172 260.617Z",
    fill: "#EF4871"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M171.941 39.3506L181.181 41.2949L182.478 41.7803L189.449 43.4011L200.309 46.6453L208.901 49.5632L225.596 56.208C232.416 59.223 239.007 62.4645 245.374 65.9353C269.44 79.1521 290.594 95.2788 308.837 114.321C327.898 133.948 343.785 156.749 356.495 182.73C359.402 188.738 362.104 194.951 364.598 201.37L367.84 210.123L370.758 219.039L373.352 227.954L376.108 239.14L376.27 240.599L377.567 246.109V246.921L378.379 250.486L379.35 256.648H379.188C378.724 255.599 378.047 254.76 377.163 254.135C376.275 253.779 375.601 253.21 375.135 252.433L362.169 238.814L359.574 228.44L356.656 218.877L353.415 209.638L350.497 202.181C345.567 190.305 339.95 179.119 333.637 168.625C322.529 150.126 309.479 133.562 294.491 118.94C279.459 104.038 262.437 91.1258 243.427 80.1985L235.162 75.6598L219.599 68.2033L204.038 62.0438L193.826 58.6405L188.964 57.3434L188.071 56.4508L171.941 39.3506Z",
    fill: "#F47F3F"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8251 43.0772L62.4423 54.1825L47.1247 58.3139L38.0474 61.3963L27.9156 50.9383L29.2936 50.2102L38.6946 46.9686L51.8251 43.0772Z",
    fill: "#EB3885"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8079 53.1284H24.4287L26.2139 53.7756C27.5623 54.5334 28.7246 55.4799 29.6981 56.6126C31.1895 58.2549 32.3788 60.202 33.2633 62.4484L61.1452 144.311L62.2805 147.065L63.5777 151.606C63.4158 152.199 63.4698 152.577 63.7394 152.739V156.145L63.2541 158.089L62.1996 159.791L61.6306 160.034L61.7142 160.276L61.226 160.114L59.5244 160.926L59.4435 161.25C59.1523 160.948 58.6644 160.84 57.9848 160.926L55.7139 159.791L52.7151 156.954C51.4746 155.387 50.4471 153.604 49.6353 151.606L25.6449 81.0911L21.2681 68.7723L19.6473 63.7455L19.3237 62.1248V60.8276L19.1619 60.6658V58.5597L19.6473 56.289C20.0033 55.2399 20.5723 54.4039 21.349 53.7756L22.8079 53.1284Z",
    fill: "#EB3885"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M107.912 135.315H109.695L110.018 135.476L128.256 148.362L126.067 148.443L125.905 148.281L115.207 148.281L115.045 148.443L109.371 148.607L109.21 148.769L107.424 148.769L107.262 148.931L102.562 149.254L102.4 149.416L101.264 149.416L101.103 149.578L96.7258 150.063L92.9989 150.875H92.1871L77.5167 140.581L87.0012 138.23H87.8103L93.1606 137.097L99.6437 136.286L99.8055 136.124H100.941L101.103 135.962H102.562L102.723 135.8H104.182L105.965 135.476H107.75L107.912 135.315Z",
    fill: "#EB3885"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M173.077 184.593L173.157 184.917C173.449 184.798 173.557 184.879 173.481 185.159C174.703 186.802 175.622 188.749 176.237 190.995L176.884 194.237L177.046 197.804L176.884 197.966L176.723 200.965C186.191 206.445 194.511 213.117 201.687 220.983L204.443 224.065L204.2 223.982L174.047 208.098L172.588 210.204L172.834 209.8L172.996 209.476L173.077 184.593Z",
    fill: "#EB3885"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M291.654 196.426L299.353 197.562L299.515 197.723H300.489L303.568 198.371H304.542L306.648 198.856H307.622L308.35 199.263L314.997 213.203L318.886 222.93L319.048 223.82L310.378 222.523L310.216 222.361H309.242L306.163 221.714H305.189L304.054 221.39L303.811 221.471L302.514 218.065L299.272 210.935L291.654 196.426Z",
    fill: "#EB3885"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M256.558 238.572L275.282 251.783L276.417 255.836L276.091 255.674L274.716 254.135C273.925 253.517 272.952 253.086 271.798 252.837C271.126 253.032 270.695 252.978 270.501 252.676H261.747L261.504 252.433L259.719 246.759L256.558 238.572Z",
    fill: "#EB3885"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M218.302 252.676L222.274 252.756L218.302 252.837V252.676Z",
    fill: "#EB3885"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M322.373 252.676H327.397L327.801 252.837V266.777L321.076 266.777L320.021 266.372V253.404L320.426 252.999C320.59 253.269 320.752 253.215 320.914 252.837L321.885 252.999L322.373 252.676Z",
    fill: "#EB3885"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M232.163 252.837L269.77 252.837V266.777H249.913L249.751 266.939H217.493V266.777H232.163V252.837Z",
    fill: "#EB3885"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M317.672 254.458L317.753 254.782L317.265 255.025L317.022 255.432L316.941 255.189L317.672 254.458Z",
    fill: "#EB3885"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M213.278 254.62L213.52 254.701L213.035 255.025L212.954 255.27L212.873 255.025L213.278 254.62Z",
    fill: "#EB3885"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M316.049 256.564L316.132 256.81L315.563 258.188L315.483 257.78L316.049 256.564Z",
    fill: "#EB3885"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M315.402 258.349L315.482 259.239H315.321L315.402 258.349Z",
    fill: "#EB3885"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M315.24 259.482L315.321 260.053H315.159L315.24 259.482Z",
    fill: "#EB3885"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M112.289 34.1619H125.905L126.067 34.3237H131.091L131.256 34.4853L139.359 34.8118L139.521 34.9734L146.816 35.459L146.978 35.6209L148.275 35.6208L149.734 35.9446L155.084 36.4325L155.246 36.5946L161.567 37.4034L161.729 37.5658L163.838 37.7297L165.62 38.2154L168.215 38.5387L168.7 38.8623L169.024 38.7005L170.483 39.1886L170.806 39.0241L171.618 39.1886L174.455 42.0229L188.88 57.2624L188.637 57.1815L187.666 57.0197L187.34 56.6933H187.016C186.563 56.7796 186.294 56.6718 186.207 56.3697H185.881L170.968 52.8046L165.944 51.8311H165.132L163.35 51.3457H162.541L161.567 51.022L159.461 50.8575L159.296 50.6957L152.975 49.8867L152.813 49.7249H151.516L151.354 49.5631L148.76 49.3986L148.598 49.2368L146.007 49.075L145.842 48.9132H144.383L144.221 48.7514H142.439L142.277 48.5896L138.712 48.4278L138.547 48.266H136.441L136.279 48.1041H133.523L133.362 47.9396L124.608 47.7778L124.446 47.616L113.748 47.6161L113.586 47.7778L111.154 47.778L98.9158 35.0545C99.6385 34.7525 100.585 34.6689 101.753 34.8118L101.915 34.6473L107.75 34.4855L107.912 34.3237H112.127L112.289 34.1619Z",
    fill: "#F0665D"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6995 34.9735L98.2674 35.0546L97.6995 35.1357V34.9735Z",
    fill: "#F0665D"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9174 35.1354L96.323 35.2165L95.9174 35.2976V35.1354Z",
    fill: "#F0665D"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1318 35.2972L94.7024 35.3783L94.1318 35.4595V35.2972Z",
    fill: "#F0665D"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M92.511 35.4591L92.9194 35.5402L92.511 35.6213V35.4591Z",
    fill: "#F0665D"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0521 35.6209L91.4605 35.7021L91.0521 35.7832V35.6209Z",
    fill: "#F0665D"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5932 35.7828L90.0016 35.8639L89.5932 35.9451V35.7828Z",
    fill: "#F0665D"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1344 35.9442L88.5427 36.0254L88.1344 36.1065V35.9442Z",
    fill: "#F0665D"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M86.84 36.1061L87.2456 36.1899L86.84 36.2711V36.1061Z",
    fill: "#F0665D"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5429 36.2705L85.9485 36.3516L85.5429 36.4328V36.2705Z",
    fill: "#F0665D"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M107.424 47.778L108.64 47.8589L107.424 47.9398V47.778Z",
    fill: "#F0665D"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M104.671 47.9399L105.561 48.0235L104.671 48.1044V47.9399Z",
    fill: "#F0665D"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M102.077 48.1038L102.805 48.1847L102.077 48.2656V48.1038Z",
    fill: "#F0665D"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9678 48.2659L100.538 48.3468L99.9673 48.428L99.9678 48.2659Z",
    fill: "#F0665D"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0233 48.4276L98.4289 48.5087L98.0233 48.5898V48.4276Z",
    fill: "#F0665D"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2406 48.5894L96.6463 48.6706L96.2406 48.7517V48.5894Z",
    fill: "#F0665D"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4583 48.7513L95.0259 48.8324L94.458 48.9136L94.4583 48.7513Z",
    fill: "#F0665D"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9994 48.9131L93.4048 48.9943L92.9991 49.0754L92.9994 48.9131Z",
    fill: "#F0665D"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5404 49.0749L91.9459 49.1561L91.5403 49.2373L91.5404 49.0749Z",
    fill: "#F0665D"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0814 49.2369L90.4871 49.318L90.0814 49.3991V49.2369Z",
    fill: "#F0665D"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7844 49.3983L89.19 49.4822L88.7844 49.5633V49.3983Z",
    fill: "#F0665D"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M108.398 71.2828C111.607 72.3966 114.228 74.0982 116.259 76.3905C118.378 78.5722 119.891 81.3013 120.797 84.5752L122.664 84.4134L122.826 84.5754L128.011 84.5752L128.173 84.7368L131.579 84.737L131.741 84.8987L138.548 85.2251L138.712 85.3873L147.301 86.1959L147.463 86.358L152.975 87.0077L158.649 88.1436L160.432 88.3048L175.671 91.8699L182.963 93.9788L195.123 98.1911L204.362 101.921L210.845 104.839L224.299 111.81C230.2 115.148 235.874 118.714 241.321 122.508C252.993 130.666 263.664 139.827 273.337 149.983L277.388 154.359L276.498 153.631L254.614 150.228L255.911 151.849L254.371 150.309V150.063L253.478 149.578C248.832 145.201 243.915 141.094 238.727 137.259C234.059 133.767 229.197 130.472 224.137 127.37C218.054 123.622 211.678 120.162 205.009 116.996L192.205 111.484L178.751 106.783L173.724 105.486L172.589 105L164.161 102.894L162.702 102.73L157.19 101.435H156.381L150.707 100.3L147.463 99.9764L147.301 99.8146H146.169L146.007 99.6501L142.439 99.3265L142.277 99.1647L137.577 98.8411L137.415 98.6793L130.929 98.3556L130.767 98.1911L122.175 98.0293L122.014 97.8675H120.636C119.427 101.597 117.453 104.623 114.719 106.945L111.477 109.216L108.56 110.513L108.478 71.5253L108.398 71.2828Z",
    fill: "#F0665D"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M116.828 134.827L119.177 134.907L116.828 134.988V134.827Z",
    fill: "#F0665D"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M123.311 134.827L125.013 134.907L123.311 134.988V134.827Z",
    fill: "#F0665D"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M112.127 134.988L112.855 135.069L112.127 135.15V134.988Z",
    fill: "#F0665D"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M128.011 134.988L128.904 135.069L128.011 135.15L128.011 134.988Z",
    fill: "#F0665D"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M109.371 135.15L110.1 135.231L109.371 135.315V135.15Z",
    fill: "#F0665D"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M130.929 135.15L131.5 135.231L130.929 135.315L130.929 135.15Z",
    fill: "#F0665D"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M106.939 135.315L107.344 135.396L106.939 135.477V135.315Z",
    fill: "#F0665D"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M133.038 135.315L133.444 135.396L133.038 135.476L133.038 135.315Z",
    fill: "#F0665D"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M105.318 135.477L105.723 135.558L105.318 135.639V135.477Z",
    fill: "#F0665D"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M134.821 135.477L135.226 135.558L134.821 135.639V135.477Z",
    fill: "#F0665D"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M103.697 135.638L104.103 135.72L103.697 135.801V135.638Z",
    fill: "#F0665D"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M136.441 135.638L136.847 135.72L136.441 135.8L136.441 135.638Z",
    fill: "#F0665D"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M102.077 135.8L102.482 135.881L102.077 135.963V135.8Z",
    fill: "#F0665D"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M139.359 135.962L139.765 136.043L139.359 136.124V135.962Z",
    fill: "#F0665D"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M143.089 136.448L143.495 136.528L143.089 136.61L143.089 136.448Z",
    fill: "#F0665D"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M116.34 148.281L118.529 148.362L116.34 148.443V148.281Z",
    fill: "#F0665D"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M123.634 148.281L124.851 148.362L123.634 148.443V148.281Z",
    fill: "#F0665D"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M112.451 148.443L113.019 148.524L112.451 148.608V148.443Z",
    fill: "#F0665D"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M128.011 148.443L128.742 148.524L128.011 148.607V148.443Z",
    fill: "#F0665D"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M109.695 148.607L110.263 148.688L109.695 148.77V148.607Z",
    fill: "#F0665D"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M130.606 148.607L131.174 148.688L130.606 148.77V148.607Z",
    fill: "#F0665D"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M132.55 148.769L132.958 148.85L132.55 148.931V148.769Z",
    fill: "#F0665D"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M134.335 148.931L134.741 149.012L134.335 149.093V148.931Z",
    fill: "#F0665D"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M135.956 149.092L136.362 149.174L135.956 149.255V149.092Z",
    fill: "#F0665D"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M176.965 194.805L177.046 195.534H176.885L176.965 194.805Z",
    fill: "#F0665D"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M176.966 198.371L177.047 198.941H176.885L176.966 198.371Z",
    fill: "#F0665D"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M362.25 238.898L376.513 253.811C377.4 254.167 378.074 254.733 378.541 255.513L379.107 256.402L379.269 256.079L379.35 256.322L379.188 256.648L379.838 258.43V261.187C379.393 263.066 378.503 264.498 377.163 265.483L375.054 266.615L373.433 266.939H321.561V266.777H347.172L347.256 266.696L347.256 252.837L365.006 252.837L365.087 252.433L363.466 244.976V244.165L362.816 241.897V241.57L362.25 238.898Z",
    fill: "#F0665D"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M271.309 252.837L271.715 252.919L271.309 253V252.837Z",
    fill: "#F0665D"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M271.148 266.777L271.878 266.858L271.148 266.939V266.777Z",
    fill: "#F0665D"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M104.021 70.3121L104.427 70.3932L104.021 70.4739L104.021 70.3121Z",
    fill: "#DD2B8D"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M156.217 176.324L156.625 176.406L156.217 176.487V176.324Z",
    fill: "#DD2B8D"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M158.649 176.324L159.055 176.406L158.649 176.487V176.324Z",
    fill: "#DD2B8D"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M159.38 176.486L160.108 176.648L160.432 176.486L161.244 176.813H161.567L161.891 176.974H162.214L163.026 177.298H163.35L164.485 177.622L164.809 177.945H165.132L166.999 178.757C166.869 179.081 167.004 179.188 167.403 179.081C169.035 180.097 170.467 181.313 171.699 182.729L172.996 184.512L172.996 209.476C172.227 210.762 171.284 211.868 170.16 212.799L167.079 215.066L164.809 216.202H164.323L164 216.525L162.379 216.851L161.891 217.175H161.567L161.082 217.337H160.755L160.108 217.499L159.785 217.337L159.38 217.499V176.486Z",
    fill: "#DD2B8D"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M156.867 217.499L157.272 217.58L156.867 217.661V217.499Z",
    fill: "#DD2B8D"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M158.002 217.499L158.408 217.58L158.002 217.661L158.002 217.499Z",
    fill: "#DD2B8D"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M313.215 250.405L326.993 252.595L320.752 252.837C319.053 253.301 317.732 254.14 316.78 255.351C315.86 256.322 315.348 257.7 315.24 259.482L314.997 259.078L314.674 256.648L313.215 250.405Z",
    fill: "#DD2B8D"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M210.036 258.023L211.09 258.511L211.007 260.617L210.036 258.023Z",
    fill: "#DD2B8D"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6727 50.8576L31.1569 54.1827L37.9635 61.313L33.5057 63.0173C32.3299 59.8729 30.5987 57.2786 28.3199 55.2345L25.5638 53.4519L24.4287 53.1284H22.8079L21.349 53.7756L21.8368 53.1283L27.6727 50.8576Z",
    fill: "#ED2E8B"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1123 140.662C77.6841 140.576 78.0643 140.684 78.2477 140.986L92.1064 150.794C92.1711 151.096 91.8745 151.177 91.2138 151.037L82.6246 152.981L75.977 154.928L62.6038 145.444L69.0059 143.095L77.1123 140.662Z",
    fill: "#ED2E8B"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6586 152.173L63.7397 152.578H63.5774L63.6586 152.173Z",
    fill: "#ED2E8B"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8204 153.631L63.9016 154.037H63.7393L63.8204 153.631Z",
    fill: "#ED2E8B"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M174.047 208.098L204.2 223.982L204.928 224.713C210.451 231.131 215.206 238.318 219.194 246.274L218.952 246.354L195.608 234.033L194.23 232.817C192.178 230.225 189.934 227.82 187.505 225.606C182.37 220.687 176.669 216.337 170.402 212.556C171.893 211.345 173.109 209.859 174.047 208.098Z",
    fill: "#ED2E8B"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M304.054 221.39L305.189 221.714H306.163L309.242 222.361H310.216L312.322 222.849H313.295L313.457 223.011L319.212 223.82L323.589 237.355L323.343 237.439L318.158 236.465H317.184L315.078 235.98H314.104L311.025 235.33L309.08 235.168L308.838 234.925C307.443 230.322 305.823 225.945 303.973 221.795L304.054 221.39Z",
    fill: "#ED2E8B"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M217.978 252.837H232.163V266.777H216.843C215.764 266.561 214.871 266.157 214.17 265.563V254.215L214.413 253.973L216.681 252.999C217.363 253.183 217.795 253.129 217.978 252.837Z",
    fill: "#ED2E8B"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M319.779 253.323L320.021 253.404V266.372L319.779 266.291C318.784 265.989 318.001 265.477 317.427 264.752V255.024L318.158 254.296L319.779 253.323Z",
    fill: "#ED2E8B"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5229 145.363C66.8458 148.726 71.3037 151.859 75.8963 154.766C76.0365 155.122 75.8477 155.23 75.3299 155.09C69.7961 156.797 64.5536 158.795 59.6051 161.088V160.926L62.0375 159.952L62.6039 159.386L63.4156 157.765L63.7392 156.468C63.5558 155.3 63.6098 154.381 63.901 153.712L63.7392 153.55V152.253L63.4156 151.28V150.471L61.7948 145.77L62.5229 145.363Z",
    fill: "#ED2E8C"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M194.961 233.547L218.628 246.028L219.356 246.597L222.112 252.676H218.302L217.654 252.999L216.6 252.837L216.519 253.161L216.115 252.999L216.034 253.323L215.629 253.161L215.548 253.485L215.222 253.323L214.817 253.566L214.898 253.811L214.575 253.649V253.973L214.332 253.892L214.17 254.215L214.089 265.644C212.986 264.865 212.148 263.811 211.576 262.481L211.252 261.348L211.09 259.566L211.252 258.511L210.198 258.188L209.955 258.269C210.225 258.107 210.171 257.942 209.793 257.781L208.496 254.701L204.119 246.435C201.331 241.764 198.278 237.471 194.961 233.547Z",
    fill: "#ED2E8C"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M308.919 235.006L314.104 235.98H315.078L317.184 236.465H318.158L321.238 237.113L323.182 237.274L323.589 237.439L325.048 242.382L327.478 252.595L327.073 252.676L324.964 252.19H323.994L323.832 252.026L313.215 250.405L310.944 241.57L308.919 235.006Z",
    fill: "#ED2E8C"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M317.508 254.781L317.427 255.024L317.346 264.671C315.995 263.589 315.321 261.834 315.321 259.401C315.569 259.272 315.623 258.948 315.482 258.43L315.402 258.188C315.682 258.274 315.763 258.139 315.644 257.78L316.456 255.998L316.941 255.512L316.861 255.27C317.001 255.518 317.136 255.491 317.265 255.189L317.508 254.781Z",
    fill: "#ED2E8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4e09e51e36010fc492ed584642ed3d15.svg";
export { ForwardRef as ReactComponent };